import React, { useEffect } from "react";
import { setActiveMenu } from "../../../../redux/slice/activeMenuSlice";
import { useDispatch, useSelector } from "react-redux";
import Profile from "./Profile";
import EmployeeDocs from "./EmployeeDocs";
import UploadDocuments from "./UploadDocuments";
import { useLocation } from 'react-router-dom';
import { useHasPermission } from "../../../../hooks/useHasPermission";

const EmployeeProfile = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const canUploadDoc = useHasPermission("Upload Documents-manage");
  const empType = location.state?.empType;
  console.log('empType', empType)
  const activeMenu = useSelector((state) => state.activeMenu.menu || "profile");
  useEffect(() => {
    dispatch(setActiveMenu({ menu: "profile" }));
    return () => {
      dispatch(setActiveMenu({ menu: "" }));
    };
  }, [dispatch]);

  const renderContent = () => {
    switch (activeMenu) {
      case "profile":
        return (
          <div className="profile-container">
            <Profile />
          </div>
        );
      case "documents":
        return (
          <div>
            <EmployeeDocs />
          </div>
        );
      case "uploaddocuments":
        return (
          <div>
            <UploadDocuments />
          </div>
        );
      default:
        return <div className="profile-container"></div>;
    }
  };

  const handleNavClick = (menu) => {
    dispatch(setActiveMenu({ menu: menu.toLowerCase().replaceAll(/\s+/g, "") }));
  };

  return (
    <div className="container-fluid">
      <div className="navbar-container">
        {((empType === "EXISTING_EMP" || canUploadDoc ) ? ["Profile", "Documents", "Upload Documents"] : ["Profile", "Documents"]).map((menu) => (
          <button type="buton"
            key={menu}
            className={`btn-interactive nav-link ${activeMenu === menu.toLowerCase().replaceAll(/\s+/g, "") ? "active" : ""}`}
            onClick={() => handleNavClick(menu)}>
            {menu}
          </button>
        ))}
      </div>

      {renderContent()}
    </div>
  );
};

export default EmployeeProfile;
